import { createSelector } from '@reduxjs/toolkit';
import { getRoute } from 'slices/routes';

export const routeSelector = createSelector([getRoute], routeData => {
  return {
    route: routeData
  };
});
